import { connect } from 'react-redux';
import checkExercise from '../actions/actionCreators/checkExercise';
import hideCompletionPane from '../actions/actionCreators/hideCompletionPane';
import showExercise from '../actions/actionCreators/showExercise';
import showHint from '../actions/actionCreators/showHint';
import takeSolution from '../actions/actionCreators/takeSolution';
import NormalExercise from '../components/NormalExercise';
import mainApiClient from '../lib/mainApiClient';
import selectCompletionPaneVisible from '../selectors/selectCompletionPaneVisible';
import selectFeedbackMessagesForExercise from '../selectors/selectFeedbackMessagesForExercise';
import selectInteractionBlocked from '../selectors/selectInteractionBlocked';
import selectSolutionShown from '../selectors/selectSolutionShown';
import selectSuccessMessage from '../selectors/selectSuccessMessage';
import selectXpLost from '../selectors/selectXpLost';
const mapStateToProps = (state, _ref) => {
  let {
    environment,
    exercise,
    exerciseId
  } = _ref;
  return {
    completionPaneVisible: selectCompletionPaneVisible(state, exerciseId),
    feedbackMessages: selectFeedbackMessagesForExercise(state, exerciseId),
    interactionBlocked: selectInteractionBlocked(state, exerciseId),
    onRate: (() => {
      if (exercise === undefined) {
        return undefined;
      }
      const {
        externalId,
        isRatingPermitted
      } = exercise;
      if (!isRatingPermitted || externalId === null) {
        return undefined;
      }
      return payload => mainApiClient(environment).rateExercise(externalId, payload);
    })(),
    solutionShown: selectSolutionShown(state, exerciseId),
    successMessage: selectSuccessMessage(state, exerciseId),
    xpLost: selectXpLost(state, exerciseId)
  };
};
const mapsDispatchToProps = (dispatch, _ref2) => {
  let {
    environment,
    exerciseId,
    workbook
  } = _ref2;
  return {
    hideCompletionPane: () => dispatch(hideCompletionPane(exerciseId)),
    showExercise: () => dispatch(showExercise(exerciseId)),
    showHint: _ref3 => {
      let {
        message,
        xpCost
      } = _ref3;
      return dispatch(showHint({
        environment,
        exerciseId,
        message,
        xpCost
      }));
    },
    showSolution: xpCost => workbook === undefined ? () => {
      // noop
    } : dispatch(takeSolution(exerciseId, xpCost, environment)),
    submitExercise: () => dispatch(checkExercise(exerciseId, environment))
  };
};
export default connect(mapStateToProps, mapsDispatchToProps)(NormalExercise);